// Validation patterns for notify-contact fields, shared by the HRIS dashboard
// controller (.ts) and notify-contacts-modal component (.gts). Lives in a plain
// .ts module because type-aware eslint cannot resolve types exported from .gts.

// Lightweight shape check (one @, a dot in the domain) — server does real validation.
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// E.164: leading +, 2-15 digits, no leading zero.
export const E164_PATTERN = /^\+[1-9]\d{1,14}$/;

// Both notify-contact fields are optional: blank is valid, anything else must
// match the pattern. Shared so the rule lives in exactly one place.
export function isInvalidEmail(value: string): boolean {
  const v = value.trim();
  return Boolean(v) && !EMAIL_PATTERN.test(v);
}

export function isInvalidE164(value: string): boolean {
  const v = value.trim();
  return Boolean(v) && !E164_PATTERN.test(v);
}
